module.exports = __webpack_public_path__ + "static/media/lott_anim.89e75f66.gif";